const semRoldana = [
  'Movimento suave e silencioso',
  'Sem desgaste mecânico ao longo do tempo',
  'Design minimalista e elegante',
  'Menor manutenção e maior durabilidade',
  'Acabamento premium sem peças expostas',
  'Aprovado para condomínios de alto padrão',
];

const comRoldana = [
  'Ruído ao abrir e fechar',
  'Desgaste das roldanas com o uso',
  'Aparência industrial e menos refinada',
  'Manutenção periódica obrigatória',
  'Peças expostas comprometem a estética',
  'Pode ser reprovado em condomínios premium',
];

export default function ComparacaoSacadas() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
            COMPARATIVO TÉCNICO
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 leading-tight">
            Sacadas Articuladas: Entenda a Diferença<br className="hidden md:block" /> que Faz Toda a Diferença
          </h2>
          <p className="text-stone-500 mt-3 text-sm max-w-xl mx-auto">
            Nem todo fechamento de sacada é igual. Veja por que o sistema sem roldana é a escolha certa para o seu imóvel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          {/* Sem Roldana */}
          <div className="bg-stone-900 rounded-2xl p-7 flex flex-col">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-award-fill text-amber-400 text-lg"></i>
              </div>
              <span className="text-amber-400 text-xs font-bold uppercase tracking-widest">Padrão Thelux</span>
            </div>
            <h3 className="text-white text-xl font-bold mb-5">Sem Roldana</h3>
            <ul className="space-y-3 flex-1">
              {semRoldana.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-white/85 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-green-400 text-base"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-6 bg-amber-500/20 border border-amber-500/30 rounded-lg px-4 py-2 text-center">
              <span className="text-amber-400 text-xs font-semibold">RECOMENDADO PELA THELUX</span>
            </div>
          </div>

          {/* Image */}
          <div className="rounded-2xl overflow-hidden h-[320px] md:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20frameless%20glass%20balcony%20enclosure%20articulated%20panels%20without%20rollers%20modern%20luxury%20apartment%20clean%20minimal%20design%20premium%20hardware%20S%C3%A3o%20Paulo&width=600&height=800&seq=comp001&orientation=portrait"
              alt="Sistema articulado sem roldana Thelux"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Com Roldana */}
          <div className="bg-stone-100 rounded-2xl p-7 flex flex-col">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-error-warning-line text-stone-400 text-lg"></i>
              </div>
              <span className="text-stone-400 text-xs font-bold uppercase tracking-widest">Padrão Genérico</span>
            </div>
            <h3 className="text-stone-700 text-xl font-bold mb-5">Com Roldana</h3>
            <ul className="space-y-3 flex-1">
              {comRoldana.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-stone-500 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-close-circle-fill text-red-400 text-base"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-6 bg-red-50 border border-red-200 rounded-lg px-4 py-2 text-center">
              <span className="text-red-400 text-xs font-semibold">NÃO RECOMENDADO</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
